<template>
    <div>
        <TwicImg :src="props.src + '?deployment=' + config.public.appVersion" :ratio="props.ratio"
            :intrinsic="props.intrinsic" :mode="props.mode" placeholder="none" />

    </div>
</template>

<script setup lang="ts">

import { useRuntimeConfig } from '#app'

const config = useRuntimeConfig()
const props = defineProps({
    src: {
        type: String,
        required: true
    },
    ratio: {
        type: String,
        default: '1/1'
    },
    intrinsic: {
        type: String,
        default: '1920x1920'
    },
    mode: {
        type: String,
        default: 'cover'
    }
})

</script>
